import questions, * as fromQuestions from './questions';
import options, * as fromOptions from './options';
import categories, * as fromCategories from './categories';
import auth, * as fromAuth from './auth';
import sync, * as fromSync from './sync';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import response from './response';
import responses from './responses';
import { SAVE_ANSWER } from '../actions/response';
import { CREATE_NEW_RESPONSE } from '../actions/responseMetadata';
import { getResults, getResponse } from '../reducer/response';
//import userEdits from '../reducer/userEdits';
import { createSelector } from 'reselect'
import filterOptions from './filterOptions';
import tags from '../reducer/tags';
import {getSortIndex} from "../sortIndex";
import translationList from './translationList';
import translations from './translations'

let _reducers = combineReducers({ questions, options, categories, routing: routerReducer, auth, sync, route: routerReducer, responses, filterOptions, tags, translationList, translations });

export default function(state={}, action) {
  let nextState = _reducers(state, action);
  switch (action.type) {
    case SAVE_ANSWER:
    case CREATE_NEW_RESPONSE:
      let results = getResults(nextState);
      let response = nextState.responses.items.find((r) => r.metadata.id === action.response.metadata.id)
      return {
        ...nextState,
        responses: {
          ...nextState.responses,
          items: [
            ...nextState.responses.items.filter((r) => r.metadata.id != response.metadata.id),
            {
              ...response,
              metadata: {
                ...response.metadata,
                qdd: nextState.sync.version,
                numAnswers: Object.keys(response.answers).length,
                completedSections: ["monitoring", "assessment", "controlRules"].reduce((list, section) => {
                  list[section] = !!results[section].complete;
                  return list
                }, {})
              }
            }
          ]
        }
      }
    default:
      return nextState;
  }
}

export const sortedOptions = (state) => fromOptions.sortedOptions(state.options)
export const optionsBySectionAndCategory = (state) => fromOptions.optionsBySectionAndCategory(state.options, state.categories) //not used?
export const sortedQuestions = (state) => fromQuestions.sortedQuestions(state.questions)
export const sortedCategories = (state) => fromCategories.sortedCategories(state.categories)
export const questionsByCategory = (state) => fromQuestions.questionsByCategory(state.questions, state.categories); //not used?
export const byTitle = (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase());
export const isSignedIn = (state) => fromAuth.isSignedIn(state.auth);

const getSection = (state) => {
  let path = state.route.locationBeforeTransitions.pathname;
  if (/monitoring/.test(path)) {
    return "monitoring";
  } else if (/assessment/.test(path)) {
    return "assessment";
  } else if (/controlRules/.test(path)) {
    return "controlRules";
  } else if (/enforcement/.test(path)){
    return "enforcement";
  } else {
    return null;
  }
}

const getQuestions = (state) => state.questions

const getOptions = (state) => state.options

const getAnswers = createSelector(
  [getResponse],
  (response) => response ? response.answers : {}
);

// const getReadOnlyAnswers = (state) => state.readOnlyResponse.answers

export const createOptionSectionLookup = (options) => {
  return options.reduce((memo, option) => {
    if (!(option.section in memo)) {
      memo[option.section] = {};
    }
    memo[option.section][option.id] = true;
    return memo;
  }, {});
}

const _questionsForSection = (section, questions, options, answers) => {
  let lookup = createOptionSectionLookup(options);
  if(section === null){return questions} // if no section provided, return all questions. needed since IntlProvider is causing rerenders on question page after being routed awawy (ie no longer a section in the pathname, but still trying to find the question cooresponging to the old path)
  let satisfiedByQuestionsInSection = questions.filter((question) => {
    let caveats = question.domainLogic.caveats;
    if (!question.satisfiedBy || !question.satisfiedBy.length) {
      return false;
    }
    for (var optionID in caveats) {
      if (lookup[section][optionID] === true) {
        return true;
      }
    }
    let criteria = question.domainLogic.criteria;
    for (var optionID in criteria) {
      if (lookup[section][optionID] === true && criteria[optionID] && criteria[optionID].length) {
        return true;
      }
    }
    return false;
  });
  let neededToSatisfy = [];
  for (let question of satisfiedByQuestionsInSection) {
    neededToSatisfy = neededToSatisfy.concat(question.satisfiedBy || []);
  }
  const result = questions.filter((question) => {
    if (question.answerType === 'satisfiedBy') {
      return false;
    }
    if (answers[question.id] && (answers[question.id].value && question.answers.map((a) => a.id).indexOf(answers[question.id].value) !== -1) && answers[question.id].answeredInSection !== section) {
      return false;
    }
    let caveats = question.domainLogic.caveats;
    for (var optionID in caveats) {
      if (Object.keys(caveats[optionID]).length) {
        if (lookup[section][optionID] === true) {
          return true;
        }
      }
    }
    let criteria = question.domainLogic.criteria;
    for (var optionID in criteria) {
      if (lookup[section][optionID] === true && criteria[optionID] && criteria[optionID].length) {
        return true;
      }
    }
    if (neededToSatisfy.indexOf(question.id) !== -1) {
      return true;
    }
    return false;
  }).sort((a, b) => (getSortIndex(section, a.sortIndex) || 0) - (getSortIndex(section, b.sortIndex) || 0));
  return result;
}

export const questionsForSectionRaw = _questionsForSection;

window.allQuestionsInOrder = (sections) => {
  let rows = [];
  for (var section of sections) {
    let answers = {};
    const state = global.store.getState();
    let questions = _questionsForSection(section, state.questions, state.options, answers);
    questions.forEach((q) => {
      answers[q.id] = {
        answeredInSection: section,
        value: q.answers[0].id
      }
      rows.push({
        id: q.id,
        question: q.title,
        section: section,
        sortIndex: q.sortIndex
      });
    });
  }
  return rows;
}

const _answeredQuestionsForSection = (section, questions, options, answers) => {
  answers = answers || {};
  //use all questions for section regardless of what section it was answered in
  var result = _questionsForSection(section, questions, options, {}).map((question) => {
    let newQuestion = {...question};
    if (answers[question.id]) {
      newQuestion.flagged = !!answers[question.id].flagged;
      let fullAnswer = question.answers.find((a) => answers[question.id].value === a.id);
      if (fullAnswer) {
        newQuestion.answerText = fullAnswer.title;
      }
    } else {
      newQuestion.answerText = null;
    }
    return newQuestion;
  });
  return result;
}

export const questionsForSection = createSelector(
  [getSection, getQuestions, getOptions, getAnswers],
  _questionsForSection
)

export const nextQuestionForSection = (section, response, state) => {
  let questions = _questionsForSection(section, state.questions, state.options, response.answers);
  return questions.find((q) => !response.answers[q.id] || q.answers.map((a) => a.id).indexOf(response.answers[q.id].value) === -1);
}

export const questionsAndAnswers = {
  monitoring: createSelector(
    [getQuestions, getOptions, getAnswers],
    (questions, options, answers) => {
      return _answeredQuestionsForSection("monitoring", questions, options, answers);
    }
  ),
  assessment: createSelector(
    [getQuestions, getOptions, getAnswers],
    (questions, options, answers) => {
      return _answeredQuestionsForSection("assessment", questions, options, answers);
    }
  ),
  controlRules: createSelector(
    [getQuestions, getOptions, getAnswers],
    (questions, options, answers) => {
      return _answeredQuestionsForSection("controlRules", questions, options, answers);
    }
  ),
  enforcement: createSelector(
    [getQuestions, getOptions, getAnswers],
    (questions, options, answers) => {
      return _answeredQuestionsForSection("enforcement", questions, options, answers);
    }
  )
}

// export const readOnlyQuestionsAndAnswers = {
//   monitoring: createSelector(
//     [getQuestions, getOptions, getReadOnlyAnswers],
//     (questions, options, answers) => {
//       return _answeredQuestionsForSection("monitoring", questions, options, answers);
//     }
//   ),
//   assessment: createSelector(
//     [getQuestions, getOptions, getReadOnlyAnswers],
//     (questions, options, answers) => {
//       return _answeredQuestionsForSection("assessment", questions, options, answers);
//     }
//   ),
//   controlRules: createSelector(
//     [getQuestions, getOptions, getReadOnlyAnswers],
//     (questions, options, answers) => {
//       return _answeredQuestionsForSection("controlRules", questions, options, answers);
//     }
//   )
// }

export const makeTitle = ({fishery, commonName, scientificName, geography}) => {
  if (commonName || scientificName) {
    return `${commonName || scientificName}${ geography ? ', ' : ''}${geography}`;
  } else {
    return fishery || "";
  }
}
